// Shared fallback message for failed data fetches, reused across redux epics.
export const GENERIC_FETCH_ERROR_MESSAGE =
  'Oops, vi har problemer med motoren... Kunne ikke hente produktene! Ta kontakt med kundesenteret hvis problemet fortsetter!';
